import {
  ArrowLeft,
  BookOpen,
  Lightbulb,
  MapPin,
  ScanSearch
} from "lucide-react";
import { BirdPhoto } from "../components/BirdPhoto";
import { MasteryPill } from "../components/MasteryPill";
import { birdLabel, type Bird } from "../data/birds";
import type { Mastery } from "../hooks/useProgress";

type BirdDetailViewProps = {
  bird: Bird;
  mastery?: Mastery;
  onBack: () => void;
  onStudy: () => void;
};

export const BirdDetailView = ({
  bird,
  mastery,
  onBack,
  onStudy
}: BirdDetailViewProps) => (
  <main className="page detail-page">
    <button className="back-button" onClick={onBack}>
      <ArrowLeft size={19} />
      返回鸟库
    </button>
    <section className="detail-hero">
      <BirdPhoto images={bird.images} alt={birdLabel(bird)} eager />
      <div className="detail-hero__content">
        <div className="detail-hero__meta">
          <span>图卡 {bird.id}</span>
          <MasteryPill mastery={mastery} />
        </div>
        <h1>{bird.name}</h1>
        {bird.variant && <strong className="variant-label">{bird.variant}</strong>}
        <div className="detail-tags">
          <span>
            <MapPin size={15} />
            {bird.habitat}
          </span>
          <span>{bird.group}</span>
          <span>难度 {"●".repeat(bird.difficulty)}{"○".repeat(3 - bird.difficulty)}</span>
        </div>
        <p>{bird.intro}</p>
        <button className="button button--primary" onClick={onStudy}>
          <BookOpen size={18} />
          用学习卡记住它
        </button>
      </div>
    </section>

    <section className="detail-grid">
      <article className="detail-card detail-card--memory">
        <div className="detail-card__icon">
          <Lightbulb size={23} />
        </div>
        <span className="section-kicker">一句话记忆</span>
        <h2>{bird.memory}</h2>
      </article>
      <article className="detail-card">
        <div className="detail-card__icon">
          <ScanSearch size={23} />
        </div>
        <span className="section-kicker">一眼特征</span>
        <ol className="detail-feature-list">
          {bird.keyMarks.map((mark, index) => (
            <li key={mark}>
              <b>{index + 1}</b>
              <span>{mark}</span>
            </li>
          ))}
        </ol>
      </article>
      <article className="detail-card detail-card--compare">
        <span className="compare-badge">VS</span>
        <span className="section-kicker">相似鸟辨析</span>
        <h2>{bird.similar.name}</h2>
        <p>{bird.similar.difference}</p>
      </article>
    </section>
  </main>
);
